import { Component } from "react";
import '../IpPatientDetails.css';
import {
  Box, Paper, TextField, Button, Stack, Tooltip, Grid, IconButton, Autocomplete, Typography,
  ListItem, ListItemText, Divider
} from "@mui/material";
import DeleteIcon from '@mui/icons-material/Delete';
import {
  DataGrid, GridCsvExportMenuItem, GridToolbarColumnsButton, GridToolbarContainer,
  GridToolbarDensitySelector, GridToolbarExportContainer, GridToolbarFilterButton, GridToolbarQuickFilter
} from '@mui/x-data-grid';
import { withTranslation } from 'react-i18next';
import {
  CommonPatientDetails, CommonPatientCard, CommonPopUp,
  ConfirmPopup, ConsultantPatientCard, DeletePopup
} from "../../../../../Components/Common Components/CommonComponents";
import { ImagePaths } from "../../../../../Utility/ImagePaths";
import { Colors } from "../../../../../Styles/Colors";
import ToastMsg from '../../../../../Components/ToastMsg/ToastMsg';
import RestAPIService from "../../../../../Utility/Services/RestAPIService";
import { Serviceurls } from "../../../../../Utility/API/Serviceurls";
import { getCachevalue, localGetItem } from "../../../../../Utility/Services/CacheProviderService";
import { t } from "i18next";
import { CheckAccessFunc } from "../../../../../Components/CommonFunctions/CommonFunctions";
import Loader from '../../../../../Components/Loader';
import CommonDatePicker from "../../../../../Components/Common Components/CommonDatePicker";
import { TemplatePopup } from "../../../../Doctor/DoctorNotes/SarasOtherDocNotes/SarasCommonComp";

const getId = (item) => item?.service_details_id || item?.service_charge_id || item?.package_id;
class TestOrder extends Component {
  constructor(props) {
    super(props);
    this.state = {
      labDetails: [],
      labNameList: [],
      testNameList: [],
      testGrpList: [],
      patientData: {},
      attenderData: {},
      lab_name: "",
      lab_id: null,
      test_name: "",
      test_id: null,
      test_amount: null,
      test_grp: "",
      test_grp_id: null,
      test_grp_amount: null,
      spl_test: "",
      isTransmit: false,
      transmitDetail: {},
      deletedPopup: false,
      selectedRow: null,
      isSelected: false,
      selectionModel: [],
      isCheckClicked: false,
      isTransmit_Pop: false,
      isCnfClicked: false,
      isAlreadyExist: false,
      isAddCnfClicked: false,
      anchorEl: null,
      isHistoryClicked: false,
      historyData: [],
      focusError: "",
      current_page: 0,
      rowsPerPage: 10,
      withOutAppointment: {},
      showSuccessResponse: false,
      showErrorResponse: false,
      responseMessage: "",
      clinic_id: localGetItem('SelectedDoctorClinicId') ? JSON.parse(localGetItem('SelectedDoctorClinicId')) : localGetItem('clinicId') ? JSON.parse(localGetItem('clinicId')) : "",
      showCode: false,
      test_code: null,
      labTestCode: [],
      test_package: null,
      testPackageDataList: [],
      labNewTest: [],
      radNewTest: [],
      RadTestName: [],
      selecNewTestName: [],
      selecNewRadName: [],
      testDetails: [],
      fromDate: "",
      toDate: "",
      dateIndex: 0,
      NurseList: [],
      nurseName: null,

      templateList: [],
      selectedTemplateName: null,
      tempType: '',
      deleteTemplateName: null,
      templateDeletePopup: false,
      openPopupAddNew: false,
      templateName: '',
      removeData: false,
      templateLoad: false,
    }
  }
  componentDidMount() {
    let patientDetails = getCachevalue("IppatientData")
    let patients = JSON.parse(patientDetails)
    let appointmentDetail = getCachevalue("withoutAppointment");
    let details = JSON.parse(appointmentDetail);
    let showCode = JSON.parse(localGetItem('lab_test_code'))
    this.getNurseList().then(() => {
      if (details?.patient_id === patients?.patient_id) {
        this.setState({
          withOutAppointment: details,
          patientData: patients,
          showCode: showCode
        }, () => {
          this.getPatientData();
          this.getLabTestData()
          this.getRadTestData()
          this.getTestData()
          this.getLabList()
          this.getTemplateData()
        })
      } else {
        this.setState({
          patientData: patients,
          showCode: showCode
        }, () => {
          this.getPatientData();
          this.getLabTestData()
          this.getRadTestData()
          this.getTestData()
          this.getLabList()
          this.getTemplateData()
        })
      }
    });
  }

  getLabList = () => {
      this.setState({ labNameList: [] });
      try {
        let url = Serviceurls.FO_IP_LABLIST + `?clinic_id=${this.state.clinic_id}`;
        RestAPIService.getAll(url)
          .then((response) => {
            if (response.data.status === "success") {
              this.setState({
                labNameList: response.data.data,
                lab_name: response.data.data[0].laboratory_name,
                lab_id: response.data.data[0].laboratory_id,
              })
            }
          }).catch((error) => {
            if (error?.response?.data?.message) {
              this.responseSuccessErrorMessage(error.response.data.message, false)
            } else {
              this.responseSuccessErrorMessage(error.message, false)
            }
          })
      } catch (error) {
        this.responseSuccessErrorMessage(error.message, false)
      }
    }

  getLabTestData = () => {
    try {
      RestAPIService.getAll(Serviceurls.DOC_TEST_LABTEST + '?doctor_id=' + this.state.patientData.doctor_id)
        .then((response) => {
          if (response?.data?.status === 'success') {
            this.setState({
              labNewTest: response.data.data,
            })
          }
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.responseSuccessErrorMessage(error.response.data.message, false)
          } else {
            this.responseSuccessErrorMessage(error.message, false)
          }
        })
    } catch (error) {
      this.responseSuccessErrorMessage(error.message, false)
    }
  }
  getRadTestData = () => {
    try {
      RestAPIService.getAll(Serviceurls.DOC_TEST_RADTEST + '?doctor_id=' + this.state.patientData.doctor_id)
        .then((response) => {
          if (response?.data?.status === 'success') {
            this.setState({
              RadTestName: response.data.data,
            })
          }
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.responseSuccessErrorMessage(error.response.data.message, false)
          } else {
            this.responseSuccessErrorMessage(error.message, false)
          }
        })
    } catch (error) {
      this.responseSuccessErrorMessage(error.message, false)
    }
  }
  getTemplateData = () => {
    try {
      const patientId = this.state.patientData?.patient_id ?? this.state.patientData?.id;
      if (!patientId && !this.state.clinic_id) return;
      const params = `?patient_id=${patientId || ''}&clinic_id=${this.state.clinic_id || ''}`;
      RestAPIService.getAll(Serviceurls.NEW_BILLING_TEST_TEMP_GET + params)
        .then((response) => {
          if (response.data.status === "success") {
            this.setState({ templateList: response.data.data || [] });
          } else {
            this.responseSuccessErrorMessage(response.data.message, false);
          }
        })
        .catch((error) => {
          this.responseSuccessErrorMessage(error?.response?.data?.message || error?.message, false);
        });
    } catch (e) {
      this.responseSuccessErrorMessage(e?.message, false);
    }
  }

  postTestDatasFromTemplate = (lineItem, radiologyItem) => {
    const { t } = this.props;
    const states = this.state;
    let UserData = JSON.parse(localGetItem("loggedInUserInfo"));
    if (UserData?.module_name !== "nurse" && (states.nurseName === null || !states.nurseName)) {
      this.responseSuccessErrorMessage(`${t("Select")} ${t("Nurse")}`, false);
      return;
    }
    const datas = {
      ip_admission_id: states.patientData?.id ?? null,
      line_item: lineItem || [],
      radiology_item: radiologyItem || [],
      clinic_id: states.clinic_id,
      nurse_profile_id: states?.nurseName?.staff_id ?? null,
    };
    this.setState({ templateLoad: true });
    RestAPIService.create(datas, Serviceurls.IP_TEST_POST)
      .then((response) => {
        if (response.data.status === "success") {
          this.setState({ selectedTemplateName: null, templateLoad: false }, () => {
            this.getTestData();
          });
          this.responseSuccessErrorMessage(response.data.message, true);
        } else {
          this.setState({ templateLoad: false });
          this.responseSuccessErrorMessage(response.data.message, false);
        }
      })
      .catch((error) => {
        this.setState({ templateLoad: false });
        this.responseSuccessErrorMessage(error?.response?.data?.message || error?.message, false);
      });
  }

  getTemplateTestsAndPost = (selectedTemplate) => {
    if (!selectedTemplate?.id) {
      this.setState({ selectedTemplateName: null });
      return;
    }
    this.setState({ templateLoad: true });
    const params = Serviceurls.NEW_BILLING_TEST_TEMP_GET + `?id=${selectedTemplate.id}`;
    RestAPIService.getAll(params)
      .then((response) => {
        if (response.data.status !== "success") {
          this.setState({ templateLoad: false });
          this.responseSuccessErrorMessage(response?.data?.message || "Failed to load template", false);
          return;
        }
        const templateTests = response.data.data?.tests || [];
        if (templateTests.length === 0) {
          this.setState({ templateLoad: false, selectedTemplateName: null });
          this.responseSuccessErrorMessage("Template has no tests", false);
          return;
        }
        const labTests = templateTests
          .filter((item) => item?.test_type === "Laboratory")
          .map((item) => ({
            grp_id: item?.grp_id ?? null,
            test_id: item?.lab_test_ids ?? item?.test_id ?? null,
            service_code: item?.service_code ?? null,
            service_name: item?.service_name ?? null,
            service_head_id: item?.service_head_id ?? null,
            head_name: item?.service_head_name ?? null,
            head_code: item?.service_head_code ?? null,
            service_details_id: item?.service_details_id ?? null,
            service_charge_id: item?.service_charge_id ?? null,
          }));
        const radiologyItem = templateTests
          .filter((item) => item?.test_type !== "Laboratory" && item?.test_type !== "Special Test")
          .map((element) => ({
            head_code: element?.service_head_code ?? "",
            head_name: element?.service_head_name ?? "",
            module_type: (element?.test_type || "").toUpperCase() ?? "",
            service_charge_id: element?.service_charge_id ?? null,
            service_code: element?.service_code ?? null,
            service_details_id: element?.service_details_id ?? null,
            service_head_id: element?.service_head_id ?? null,
            service_name: element?.service_name ?? "",
          }));
        this.postTestDatasFromTemplate(labTests, radiologyItem);
      })
      .catch((error) => {
        this.setState({ templateLoad: false });
        this.responseSuccessErrorMessage(error?.response?.data?.message || error?.message, false);
      });
  }

  postNewTemplateData = () => {
    try {
      if (!this.state.templateName?.trim()) {
        this.responseSuccessErrorMessage("Please Enter Template Name", false);
        return;
      }
      if (this.state.testDetails?.length === 0 && this.state.tempType !== "rename") {
        this.responseSuccessErrorMessage("Please add tests to create template", false);
        return;
      }
      let data = {};
      if (this.state.tempType === "rename") {
        data = { id: this.state.selectedTemplateName?.id, name: this.state.templateName };
      } else {
        data = {
          patient_id: this.state.patientData?.patient_id ?? this.state.patientData?.id,
          clinic_id: this.state.clinic_id,
          name: this.state.templateName,
          tests: this.state.testDetails?.map((item) => ({
            ...item,
            test_id: item?.lab_test_ids ?? item?.test_id ?? null,
            grp_id: item?.lab_set_ids ?? item?.grp_id ?? null,
          })) ?? [],
        };
      }
      RestAPIService.create(data, Serviceurls.NEW_BILLING_TEST_TEMP_GET)
        .then((response) => {
          if (response.data.status === "success") {
            this.responseSuccessErrorMessage(response.data.message, true);
            this.setState({ openPopupAddNew: false, templateName: "", selectedTemplateName: null }, () => {
              this.getTemplateData();
            });
          } else {
            this.responseSuccessErrorMessage(response.data.message, false);
          }
        })
        .catch((error) => {
          this.responseSuccessErrorMessage(error.response.data.message || error?.message, false);
        });
    } catch (e) {
      this.responseSuccessErrorMessage(e?.message, false);
    }
  }

  deleteTemplateData = () => {
    const { deleteTemplateName } = this.state;
    try {
      this.setState({ removeData: true });
      RestAPIService.delete(Serviceurls.NEW_BILLING_TEST_TEMP_GET + `?id=${deleteTemplateName?.id}`)
        .then((response) => {
          if (response.data.status === "success") {
            this.responseSuccessErrorMessage(response.data.message, true);
            this.setState({
              openPopupAddNew: false,
              deleteTemplateName: null,
              selectedTemplateName: null,
              templateDeletePopup: false,
              removeData: false,
            });
            this.getTemplateData();
          } else {
            this.setState({ removeData: false });
            this.responseSuccessErrorMessage(response.data.message, false);
          }
        })
        .catch((error) => {
          this.setState({ removeData: false });
          this.responseSuccessErrorMessage(error?.message || error?.message, false);
        });
    } catch (e) {
      this.setState({ removeData: false });
      this.responseSuccessErrorMessage(e?.message, false);
    }
  }

  getTestData = () => {
    try {
      let fromDate = this.state.dateIndex == 0 ? '' : this.state.fromDate
      let toDate = this.state.dateIndex == 0 ? '' : this.state.toDate
      RestAPIService.getAll(Serviceurls.IP_TEST_POST + `?ip_admission_id=${this.state.patientData.id}&from_date=${fromDate}&to_date=${toDate}&clinic_id=${this.state.clinic_id}`)
        .then((response) => {
          if (response?.data?.status === 'success') {
            const mappedTestData = response.data.data.map(item => {
              let nurse_name = "-";
              if (item.nurse_profile_id && this.state.NurseList?.length > 0) {
                const foundNurse = this.state.NurseList.find(
                  nurse => nurse.staff_id === item.nurse_profile_id
                );
                nurse_name = foundNurse ? foundNurse.nurse : "-";
              }

              return {
                ...item,
                nurse_name: nurse_name
              };
            });
            this.setState({
              testDetails: mappedTestData,
            })
          }
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.responseSuccessErrorMessage(error.response.data.message, false)
          } else {
            this.responseSuccessErrorMessage(error.message, false)
          }
        })
    } catch (error) {
      this.responseSuccessErrorMessage(error.message, false)
    }
  }

  getLabPrint = () => {
      try {
        let fromDate = this.state.dateIndex == 0 ? '' : this.state.fromDate
        let toDate = this.state.dateIndex == 0 ? '' : this.state.toDate
        RestAPIService.getAll(`${Serviceurls.IP_TEST_POST}?ip_admission_id=${this.state.patientData.id}&from_date=${fromDate}&to_date=${toDate}&clinic_id=${this.state.clinic_id}&export_type=pdf` )
        .then((response) => {
            const file = new Blob(
              [response.data],
              { type: 'application/pdf' });
            const fileURL = URL.createObjectURL(file);
            window.open(fileURL);
          }).catch((error) => {
            this.responseSuccessErrorMessage(error.response.data.message, false);
          })
      } catch (error) {
        this.responseSuccessErrorMessage(t("PrintError"), false);
      }
    }

  LoaderFunction = (key) => {
    this.setState({
      isLoader: key
    })
  }

  getNurseList = () => {
    return new Promise((resolve, reject) => {
        try {
            RestAPIService.getAll(Serviceurls.FO_STAFF_LIST + `?clinic_id=${this.state.clinic_id}`)
                .then((response) => {
                    if (response.data.status === "success") {
                        this.setState({
                          NurseList: response.data.data
                        }, () => {
                          if (this.state.NurseList?.length && localGetItem("NurseId") && !this.state?.nurseName?.staff_id) {
                            let nurseId = JSON.parse(localGetItem("NurseId"))
                            let nurseData = this.state.NurseList.find((item) => item.staff_id === nurseId)
                            this.setState({
                              nurseName: nurseData
                            })
                          }
                          resolve(response.data.data);
                        });
                    }
                }).catch((error) => {
                    this.errorMsgFunc(error?.response?.data?.message || error.message);
                    reject(error);
                })
        } catch (error) {
            this.errorMsgFunc(error.message);
            reject(error);
        }
    });
}

  getPatientData = () => {
    this.setState({
      attenderData: {}
    })
    let admission_id = this.state.patientData?.id || this.state.withOutAppointment?.ip_admission_id;
    let url = `${(localGetItem('isNewBilling') === "false" ? Serviceurls.IP_PATIENT_DETAILS : Serviceurls.IP_PATIENT_DETAILS_NEW)}?admission_id=${admission_id}&clinic_id=${this.state.clinic_id}`;
    // if (this.props.is_From_IpNotes && this.state.clinic_id) {
    //   url = `${url}&clinic_id=${this.state.clinic_id}`
    // }
    try {
      RestAPIService.getAll(url)
        .then((response) => {
          if (response.data.status === "success") {
            this.setState({
              attenderData: response.data.data[0]
            })
          }
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.responseSuccessErrorMessage(error.response.data.message, false)
          } else {
            this.responseSuccessErrorMessage(error.message, false)
          }
        })
    } catch (error) {
      this.responseSuccessErrorMessage(error.message, false)
    }
  }



  responseSuccessErrorMessage(message, type) {
    this.setState({
      showSuccessResponse: message ? type : false,
      showErrorResponse: message ? !type : false,
      responseMessage: message
    })
  }

  handleTransmit = (isSingle = false) => {
    try {
      let data = {};
      if(isSingle){
         data = {
          "ip_admission_id": this.state.patientData.id ? this.state.patientData.id : null,
          "is_transmit": true,
          "line_item": this.state.transmitDetail.is_lab ? [this.state.transmitDetail] : [],
          "radiology_item": this.state.transmitDetail.is_rad ? [this.state.transmitDetail] : [],
          "clinic_id": this.state.clinic_id
        }
      }else{
        let labData = [];
        let RadData = [];
        this.state.selectedRows.map((data) => {
          if(data.is_lab){
            labData.push(data)
          }else if(data.is_rad){
            RadData.push(data)
          }
        })
        data = {
          "ip_admission_id": this.state.patientData.id ? this.state.patientData.id : null,
          "is_transmit": true,
          "line_item": labData,
          "radiology_item": RadData,
          "clinic_id": this.state.clinic_id
        }
      }
      RestAPIService.create(data, Serviceurls.IP_TEST_POST)
        .then(response => {
          if (response.data.status === "success") {
            this.transmitPopClose();
            this.getTestData()
            this.handleClear()
            this.responseSuccessErrorMessage(response.data.message, true);
          }
        }
        ).catch(error => {
          this.setState({ isCnfClicked: false, isAdd: false, });
          if (error?.response?.data?.status === "fail") {
            this.responseSuccessErrorMessage(error.response.data.message, false);
          } else {
            this.responseSuccessErrorMessage(error.message, false);
          }
        });

    } catch (error) {
      this.setState({ isCnfClicked: false, isAdd: false, });
      this.responseSuccessErrorMessage(error.message, false);
    }
  }

  handleClear = () => {
    this.setState({
      selecNewTestName: [],
      selecNewRadName: [],
      transmitDetail:{},
      selectedRows: [], 
      nurseName: null,
    }, () => {
      if (this.state.NurseList?.length && localGetItem("NurseId") && !this.state?.nurseName?.staff_id) {
        let nurseId = JSON.parse(localGetItem("NurseId"))
        let nurseData = this.state.NurseList.find((item) => item.staff_id === nurseId)
        this.setState({
          nurseName: nurseData
        })
      }
    })
  }
  handleAdd = () => {
    const { t } = this.props
    let UserData = JSON.parse(localGetItem("loggedInUserInfo"));
    let states = this.state;
    if (UserData?.module_name !== "nurse" && (states.nurseName === null || !states.nurseName)) {
        this.responseSuccessErrorMessage(`${t("Select")} ${t("Nurse")}`, false);
        this.setState({ isAdd: false });
        return; 
    }
    let datas = {
      "ip_admission_id": states.patientData.id ? states.patientData.id : null,
      "line_item": states.selecNewTestName || [],
      "radiology_item": states.selecNewRadName || [],
      "clinic_id": this.state.clinic_id,
      'nurse_profile_id': states?.nurseName?.staff_id || null,
    }
    try {
      this.LoaderFunction(true)
      RestAPIService.create(datas, Serviceurls.IP_TEST_POST)
        .then(response => {
          if (response.data.status === "success") {
            this.handleClear();
            this.transmitPopClose();
            this.setState({ isAdd: false })
            this.getTestData()
            this.LoaderFunction(false)
            this.responseSuccessErrorMessage(response.data.message, true);
          }
        })
        .catch(error => {
          if (error?.response?.data?.status === "fail") {
            this.setState({ isCnfClicked: false, isAdd: false, });
            this.LoaderFunction(false)
            if (error.response.data.message === "Test already entered for this admission") {
              this.setState({ isAlreadyExist: true, isAddCnfClicked: false });
            } else {
              this.responseSuccessErrorMessage(error.response.data.message, false);
            }
          }
        });
    } catch (e) {
      this.setState({ isAdd: false })
      this.responseSuccessErrorMessage(e.message, false);
    }
  }

  historyPopUpClose = () => {
    this.setState({
      anchorEl1: null,
      isHistoryClicked: false,
      historyData: []
    })
  }

  _showHistory(historydata) {
    const { t } = this.props;
    const historyColumn = [
      {
        field: 'modified_by_from', headerName: t('ModifiedBy'), sortable: false, hideable: false, flex: 0.25, renderCell: ({ row }) => {
          return (<div>{row?.modified_by_from?.length > 28 ? <Tooltip placement="top" title={row?.modified_by_from} arrow><div>{row?.modified_by_from.slice(0, 25) + "..."}</div></Tooltip> : row?.modified_by_from ? row?.modified_by_from : "-"}</div>)
        }
      },
      {
        field: 'modified_date', headerAlign: "center", headerName: t('ModifiedDateAndTime'), align: "center", sortable: false, hideable: false, flex: 0.25, renderCell: ({ row }) => {
          return (<Typography>{row?.modified_date ? row?.modified_date : "-"}</Typography>)
        }
      },
      {
        field: 'set_status_from', headerName: `${t('Previous')} ${t("Test")} ${t('Status')}`, flex: 0.25, sortable: false, hideable: false, renderCell: ({ row }) => {
          return (<div>{row?.set_status_from?.length > 30 ? <Tooltip placement="top" title={row?.set_status_from} arrow><div>{row?.set_status_from.slice(0, 26) + "..."}</div></Tooltip> : row?.set_status_from ? row?.set_status_from : "-"}</div>)
        }
      },
      {
        field: 'set_status_to', headerName: `${t('Changed')} ${t("Test")} ${t('Status')}`, flex: 0.25, sortable: false, hideable: false, renderCell: ({ row }) => {
          return (<div>{row?.set_status_to?.length > 30 ? <Tooltip placement="top" title={row?.set_status_to} arrow><div>{row?.set_status_to.slice(0, 26) + "..."}</div></Tooltip> : row?.set_status_to ? row?.set_status_to : "-"}</div>)
        }
      }
    ];
    return (
      <Box id="eMed_ipsrvConfig_accTbl">
        <DataGrid
          rows={historydata ? historydata : []}
          columns={historyColumn}
          getRowId={(row) => row.modified_date}
          disableColumnMenu
          hideFooter
          components={{
            NoRowsOverlay: () => {
              return (
                <Stack direction="row" justifyContent="center" alignItems="center" sx={{ height: "40vh" }}>
                  {t("NoRecordsFound")}
                </Stack>
              )
            }
          }}
          headerHeight={40}
        />
      </Box>
    )
  }

  msgClose() {
    this.setState({
      showSuccessResponse: false,
      showErrorResponse: false,
      responseMessage: ''
    })
  }

  getResultPrint = (value) => {
    try {
      let url = ''
      if(value?.is_rad){
        url = Serviceurls.TEST_ORDER_RAD_PRINT + `?id=${value?.result_id}&export_type=pdf&radiology_id=${value?.radiology_id || ''}`
      }else{
        url = Serviceurls.LAB_PATIENT_RESULT_PRINT + `?result_summary_id=${value.result_summary_id}&result_item_id=${value?.result_item_id}&laboratory_id=${this.state.lab_id}`
      }
      RestAPIService.getAll(url)
        .then((response) => {
          const file = new Blob(
            [response.data],
            { type: 'application/pdf' });
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL);
        }).catch((error) => {
          this.responseSuccessErrorMessage(error.response.data.message, false);
        })
    } catch (error) {
      this.responseSuccessErrorMessage(t("PrintError"), false);
    }
  }

  renderTestTemp = () => {
    const state = this.state;
    return (
      <Autocomplete
        clearIcon
        size="small"
        disabled={this.state.withOutAppointment?.is_ip || state.templateLoad}
        sx={{ width: '14vw', minWidth: '140px', marginRight: '0.5vw' }}
        options={state.templateList}
        value={state.selectedTemplateName}
        getOptionLabel={(option) => (typeof option === 'string' ? option : option?.name) ?? ''}
        onChange={(e, value) => {
          this.setState({ selectedTemplateName: value });
          if (value) this.getTemplateTestsAndPost(value);
        }}
        renderOption={(props, option) => (
          <li {...props} style={{ padding: '0vh 1.5vh' }}>
            <ListItem sx={{ display: 'flex', justifyContent: 'space-between', p: 0, m: 0 }}>
              <ListItemText
                primary={
                  option?.name?.length > 30 ? (
                    <Tooltip title={option.name} placement="top">
                      <span>{option.name.slice(0, 21) + '...'}</span>
                    </Tooltip>
                  ) : (
                    option?.name ?? ''
                  )
                }
              />
              <Tooltip title="Delete Template" placement="top" arrow>
                <IconButton
                  edge="end"
                  color="error"
                  size="small"
                  onClick={(e) => {
                    e.stopPropagation();
                    this.setState({
                      tempType: 'delete',
                      deleteTemplateName: option,
                      templateDeletePopup: true,
                    });
                  }}
                >
                  <DeleteIcon sx={{ height: '2.5vh', width: '2.5vw' }} />
                </IconButton>
              </Tooltip>
            </ListItem>
          </li>
        )}
        renderInput={(params) => <TextField {...params} label={this.props.t("Select Template")} size="small" />}
        PaperComponent={({ children }) => (
          <Paper sx={{ maxHeight: '25vw', overflow: 'auto' }}>
            {children}
            <Divider />
            <Button
              color="primary"
              fullWidth
              size="small"
              sx={{ justifyContent: 'flex-start', pl: 2, textTransform: 'capitalize' }}
              onMouseDown={(e) => {
                e.preventDefault();
                this.setState({ openPopupAddNew: true, tempType: 'Add' });
              }}
            >
              {this.props.t("Add Template")}
            </Button>
            {state.selectedTemplateName && (
              <Button
                color="primary"
                fullWidth
                size="small"
                sx={{ justifyContent: 'flex-start', pl: 2, textTransform: 'capitalize' }}
                onMouseDown={(e) => {
                  e.preventDefault();
                  this.setState({
                    openPopupAddNew: true,
                    tempType: 'rename',
                    templateName: state.selectedTemplateName?.name ?? '',
                  });
                }}
              >
                {this.props.t("Rename Template")}
              </Button>
            )}
          </Paper>
        )}
      />
    );
  }

  CustomToolbar = () => {
    const { t } = this.props;
    let UserData = JSON.parse(localGetItem("loggedInUserInfo"));
    return (
      <GridToolbarContainer className='eMed_refdoc_grid' >
        <Button variant='contained' size="small" id="eMed_recPayment_btn" disabled={this.state.withOutAppointment?.is_ip}
          sx={{ display: (this.state.isCheckClicked && !this.state.withOutAppointment?.is_ip) ? "block" : "none" }}
          onClick={() => this.setState({ isTransmit_Pop: true })}>
          {t("Transmit")}
        </Button>
        {UserData?.module_name === "nurse" && !UserData?.new_doctor_notes_template && !UserData?.new_doctor_notes_template_others  ? this.renderTestTemp() : null}
        <Tooltip placement='top' title='Show/Hide Column' arrow><GridToolbarColumnsButton /></Tooltip>
        <GridToolbarFilterButton placement='top' />
        <Tooltip placement='top' title='Table Density' arrow><GridToolbarDensitySelector /></Tooltip>
        <Tooltip placement='top' title='Export' arrow><GridToolbarExportContainer>
          <GridCsvExportMenuItem />
        </GridToolbarExportContainer>
        </Tooltip>
        <GridToolbarQuickFilter />
      </GridToolbarContainer>
    )
  }

  handleTableCheckbox = (selectedIds) => {
    let { testDetails } = this.state;

    let selectedIDs = new Set(selectedIds);
    let updatedSelection = new Set(selectedIds); // Start with the current selection

    // Step 1: Handle selection (if a package_id is selected, select all related rows)
    selectedIds.forEach((id) => {
        let selectedRow = testDetails.find((row) => row.id === id);
        if (selectedRow && selectedRow.package_id) {
            testDetails.forEach((item) => {
                if (item.package_id === selectedRow.package_id) {
                    updatedSelection.add(item.id);
                }
            });
        }
    });

    // Step 2: Handle deselection (if a package_id row is removed, remove all related rows)
    let deselectedIds = [...this.state.selectionModel].filter(id => !selectedIDs.has(id));

    deselectedIds.forEach((id) => {
        let deselectedRow = testDetails.find((row) => row.id === id);
        if (deselectedRow && deselectedRow.package_id) {
            testDetails.forEach((item) => {
                if (item.package_id === deselectedRow.package_id) {
                    updatedSelection.delete(item.id);
                }
            });
        }
    });

    let finalSelection = [...updatedSelection];

    this.setState({
        selectedRows: testDetails.filter((row) => finalSelection.includes(row.id)),
        selectionModel: finalSelection,
        isCheckClicked: finalSelection.length > 0,
    });
};


  transmitPopClose = () => {
    this.setState({
      selectedRows: [],
      selectionModel: [],
      isCheckClicked: false,
      isTransmit_Pop: false
    })
  }

  addTestAgainClose = () => {
    this.setState({
      isAlreadyExist: false,
      isAddCnfClicked: false
    })
  }

  FilterDate = (from, to, index) => {
    this.setState({
      fromDate: from,
      toDate: to,
      dateIndex: index
    }, () => {
      this.getTestData()
    })
  }

  addTestAgain = () => {
    this.setState({
      isAddCnfClicked: true
    }, () => {
      this.handleAdd()
    })
  }

  filterCustom = (options, { inputValue }) => {
  const searchTerm = inputValue?.toLowerCase()?.trim();
  if (!searchTerm) {
    return options;
  }

  const filteredOptions = options?.filter(option => {
    // Search in service_name or package_name
    if (option.service_name?.toLowerCase().includes(searchTerm) || option?.package_name?.toLowerCase().includes(searchTerm)) {
      return true;
    }
    return false;
  });
  return filteredOptions;
};

  render() {
    const { t } = this.props;
    let UserData = JSON.parse(localGetItem("loggedInUserInfo"));
    let states = this.state;

    const columns = [
       {
        field: 'created_date', headerName: `Created Date`, flex: 0.20, headerAlign: "center", align: "center", renderCell: ({ row }) => {
          return (
            <Box>{row.created_date?.length > 30 ? <Tooltip placement="top" title={row.created_date} arrow><div>{row.created_date.slice(0, 30) + "..."}</div></Tooltip> : 
            row.created_date ? row.created_date : "-"}
            </Box>
          )
        }
      },
      {
        field: 'service_name', headerName: `Test / Service`, flex: 0.40, renderCell: ({ row }) => {
          return (
            <Box>{row?.service_name?.length > 30 ? <Tooltip placement="top" title={row?.service_name} arrow><div>{row?.service_name.slice(0, 30) + "..."}</div></Tooltip> : row?.service_name ? row?.service_name : "-"}
            {row?.package_name ? <Typography fontSize={'.8vw'}>{row?.package_name}</Typography> : null}
            </Box>
          )
        }
      },
      {
        field: 'status', headerName: t('Report Status'), headerAlign: "center", align: "center", flex: 0.20, renderCell: ({ row }) => {
          let inProgress = row["status"] ? ((row["status"] === "Placed") ? "Awaiting Transmit" : row["status"] === "Result Delivered" ? "Result Completed" : row["status"]) : "Processing";
          return (<Stack sx={{ padding: "0.4vw", borderRadius: "0.2vw", backgroundColor: row["status"] === "Result Completed" || row["status"] === "Result Delivered" ? Colors.BillCompleteBg : (row["status"] !== "Result Completed" && row["status"] !== "Result Delivered" && row["status"] !== "") ? Colors.BillInProcessBg : null }}>
            <Typography sx={{ color: (row["status"] === "Result Completed" || row["status"] === "Result Delivered") ? Colors.BillCompleteTxt : (row["status"] !== "Result Completed" && row["status"] !== "Result Delivered" && row["status"] !== "") ? Colors.BillInProcessTxt : null }}>
              {inProgress ? inProgress : "-"}
            </Typography>
            {row?.is_outsource ? <Typography fontSize={'.8vw'}>{"(Outsource Test)"}</Typography> : null}
          </Stack>)
        }
      },
      {
        field: 'nurse_name', headerName: 'Nurse Name', flex: 0.2,
        renderCell: (params) => {
          let nurseName = params?.row?.nurse_name;
          return (
            <Box>
              {nurseName ? nurseName.length > 15 ?
                <Tooltip placement="top" title={nurseName}>
                  <Typography>{nurseName.slice(0, 10) + '...'}</Typography>
                </Tooltip> :
                <Typography>{nurseName}</Typography> : '-'}
            </Box>
          )
        }
      },
      {
        field: 'actions', headerAlign: 'center', headerName: t('Action'), flex: 0.10, sortable: false, hideable: false, align: "center", renderCell: ({ row }) => {
          console.log(this.props.is_From_IpNotes 
            ? false 
            : !CheckAccessFunc("front_office", "In Patients", "Clinical Notes", "Test Order", "SubTab")?.editAccess 
              ? true 
              : (states["isTransmit"] && row["status"] !== "" && row["is_transmit"]) || 
                this.state.withOutAppointment?.is_ip || 
                this.state.isCheckClicked, 'rowdata')
          return (
            <Stack direction="row" justifyContent="center" alignItems="center" >
              <Tooltip title={t("Transmit")} placement='top' arrow>
                <IconButton size="small" sx={{ display: this.state.withOutAppointment?.is_ip ? "none" : "block" }}
                  disabled={!CheckAccessFunc("front_office", "In Patients", "Clinical Notes", "Test Order", "SubTab")?.editAccess 
                        ? true 
                        : (row["status"] !== "" && row["is_transmit"]) || 
                          this.state.withOutAppointment?.is_ip || 
                          this.state.isCheckClicked
                  }
                  onClick={() => { this.setState({ isTransmit: true, transmitDetail: row }, () => { this.handleTransmit(true) }) }}>
                  <img className="emedhub_medications_img" src={(!this.state.isCheckClicked && !row?.is_transmit) ? ImagePaths.TransmitOn.default : ImagePaths.TransmitOff.default} /></IconButton>
              </Tooltip>
              <Tooltip title={t("Report")} placement='top' arrow>
                <IconButton size="small" disabled={
                  !CheckAccessFunc("front_office", "In Patients", "Clinical Notes", "Test Order", "SubTab")?.editAccess ||
                    row.is_outsource ||
                    !(row["status"] === "Result Completed" || row["status"] === "Result Delivered") ||
                    this.state.withOutAppointment?.is_ip
                } onClick={() => this.getResultPrint(row)}>
                  <img className="emedhub_medication_img" src={(!row.is_outsource && (row["status"] === "Result Completed" || row["status"] === "Result Delivered")) ? ImagePaths.IPLabOn.default : ImagePaths.IPLabOff.default} />
                </IconButton>
              </Tooltip>
            </Stack>
          )
        }
      }
    ]

    let data = {
      lineOne: t("AttenderName"),
      lineTwo: `${states["attenderData"]["attender_name"] ? states["attenderData"]["attender_name"] : "-"}`,
      lineFour: t('ContactNumber'),
      LineFive: `${states["attenderData"]["attender_mobile"] ? states["attenderData"]["attender_mobile"] : "-"}`
    }

    let Consultant = {
      image: ImagePaths.Doctor_Icon.default,
      width: "2.3vw",
      height: "2.3vw",
      lineOne: t("ConsultantName"),
      lineTwo: `${states["attenderData"]["doctor_name"] ? states["attenderData"]["doctor_name"] : "-"}`
    }
    return (
      <Box id="eMed_medication_Container" sx={{ backgroundColor: Colors.configHomeBg }}>
        <Grid container className="eMed_medication_Box" >
          <Box width={'100%'} display={'flex'} justifyContent={'space-between'} alignItems={'center'} >
            <Stack className="eMed_medicationCard_header" direction="row" justifyContent="space-evenly" alignItems="center" spacing={1.2} >
              <Stack className="eMed_recCard_div" sx={{ width: "23vw", backgroundColor: Colors.white }} >
                <CommonPatientDetails data={this.state.patientData} showDetailed={true} />
              </Stack>
              <CommonPatientCard details={data} showDetailed={true} />
              <ConsultantPatientCard name={Consultant} width={"20dvw"} />
            </Stack>
            <Box display={'flex'} flexDirection={'row'} padding={'0.5vw'}>
              <Box width={'15vw'} height={'4.5vh'} marginBottom={'1vw'}>
                <CommonDatePicker
                  FromDate={this.state.fromDate}
                  ToDate={this.state.toDate}
                  DateIndex={this.state.dateIndex}
                  SelectedDates={this.FilterDate.bind(this)}
                  OutOfOffice={true}
                  FromDateOpen={this.state.patientData.admission_date ? this.state.patientData.admission_date : null}
                  ToDateOpen={this.state.patientData.discharge_date ? this.state.patientData.discharge_date : null} />
              </Box>
              <img src={ImagePaths.LabPrintIcon.default} alt='print' style={{ width: '2vw', height: '2vw', cursor: 'pointer' }} onClick={() => this.getLabPrint()} />
            </Box>
          </Box>
          <Grid container item spacing={2} className="eMed_medication_mainDiv">
            <Grid item xs={8}>
              <Paper className="eMed_medication_Div" elevation={2}>
                <DataGrid
                  checkboxSelection
                  rows={states["testDetails"]}
                  columns={columns}
                  getRowId={(row) => row.id}
                  selectionModel={states["selectionModel"]}
                  onSelectionModelChange={(selectedIds) => this.handleTableCheckbox(selectedIds)}
                  disableSelectionOnClick={true}
                  isRowSelectable={({ row }) => row.is_transmit === false}
                  localeText={{
                    toolbarColumns: "",
                    toolbarDensity: "",
                    toolbarExport: "",
                    toolbarFilters: "",
                    toolbarExportPrint: ""
                  }}
                  components={{
                    Toolbar: this.CustomToolbar,
                    NoRowsOverlay: () => (
                      <Stack direction="row" justifyContent="center" alignItems="center" sx={{ height: "40vh" }}>
                        {t("NoRecordsFound")}
                      </Stack>
                    )
                  }}
                  headerHeight={40}
                  rowCount={states["testDetails"].length}
                  page={states["current_page"]}
                  onPageChange={(newPage) => this.setState({ current_page: newPage })}
                  pageSize={states["rowsPerPage"]}
                  onPageSizeChange={(newPageSize) => this.setState({ rowsPerPage: newPageSize })}
                  rowsPerPageOptions={[10, 20, 30]}
                  pagination
                />
              </Paper>
            </Grid>
            <Grid item xs={4}>
              <Paper className="eMed_medication_Div" elevation={2}>
                <div className="eMed_lab_subDiv">
                  <div className='eMed_medication_rightHead' style={{ backgroundColor: Colors.DataTblHeaderbg }}>
                    <p className='eMed_recPayment_rightHead_txt'>{t("Test Orders")}</p>
                  </div>
                  <Stack className="emedhub_medication_RightContentBox" direction="column" justifyContent="center" alignItems="flex-start" spacing={0.5}>
                    <Box component={'div'}>
                      <Box component={'div'}>
                        <Typography fontSize={'0.8vw'} fontWeight={600} color={Colors.SecondaryText}>Select Test</Typography>
                      </Box>
                      <Autocomplete
                        size="standard"
                        key="lab-test-autocomplete"
                        clearIcon
                        sx={{ width: "25vw", marginLeft: "1vw", marginTop: "1vw" }}
                        multiple
                        limitTags={3}
                        options={this.state.labNewTest}
                        getOptionLabel={(option) =>
                          typeof option === "string"
                            ? option
                            : option?.service_name || option?.package_name || "-"
                        }
                        value={this.state.selecNewTestName}
                        onChange={(e, value) => {
                          this.setState({ selecNewTestName: value });
                        }}
                        filterOptions={this.filterCustom}
                        isOptionEqualToValue={(option, value) => getId(option) === getId(value)}
                        renderOption={(props, option, {index}) => {
                          const { key, ...otherProps } = props;
                          const uniqueKey = `lab-test-${option?.service_details_id || option?.service_charge_id || option?.package_id}-${option?.service_code || option?.package_code}-${index}`;
                          return(
                          <Box
                            component="li"
                            key={uniqueKey}
                            {...otherProps}
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "flex-start", 
                              justifyContent: "flex-start",
                              width: "100%", 
                              textAlign: "left", 
                            }}
                          >
                            <Typography fontSize=".9vw"  sx={{ width: "100%", textAlign: "left" }} >
                              {option?.service_name || option?.package_name || "-"}
                            </Typography>
                            <Typography
                              fontSize=".8vw"
                              fontWeight="bold"
                              sx={{ width: "100%", textAlign: "left" }} 
                              color={
                                option?.test_id
                                  ? "#F1584A"
                                  : option?.grp_id
                                    ? "#29B6F6"
                                    : option?.package_id
                                      ? "#1E972A"
                                      : "inherit"
                              }
                            >
                              {option?.test_id
                                ? "Test"
                                : option?.grp_id
                                  ? "Group Test"
                                  : option?.package_id
                                    ? "Package"
                                    : ""}
                            </Typography>
                          </Box>
                        )}}
                        renderInput={(params) => <TextField {...params} label="Select Test" />}
                      />
                    </Box>
                    <Box component={'div'} marginLeft={'1vw'}>
                      <Box component={'div'}>
                        <Typography fontSize={'0.8vw'} fontWeight={600} color={Colors.SecondaryText}>Select Investigation</Typography>
                      </Box>
                      <Autocomplete
                        size="standard"
                        key="rad-test-autocomplete"
                        clearIcon
                        sx={{ width: "25vw", marginLeft: "1vw", marginTop: "1vw" }}
                        multiple
                        limitTags={3}
                        options={this.state.RadTestName}
                        filterOptions={this.filterCustom}
                        getOptionLabel={(option) =>
                          typeof option === "string"
                            ? option
                            : option?.service_name || option?.package_name || "-"
                        }
                        isOptionEqualToValue={(option, value) => getId(option) === getId(value)}
                        value={this.state.selecNewRadName}
                        onChange={(e, value) => {
                          this.setState({ selecNewRadName: value });
                        }}
                        renderOption={(props, option, {index}) => {
                          const { key, ...otherProps } = props;
                          const uniqueKey = `rad-test-${option?.service_details_id || option?.service_charge_id || option?.package_id}-${option?.service_code || option?.package_code}-${index}`;
                          return (
                          <Box
                              component="li"
                              key={uniqueKey}
                              {...otherProps}
                              sx={{
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "flex-start", 
                                  justifyContent: "flex-start",
                                  width: "100%", 
                                  textAlign: "left", 
                              }}
                          >
                              <Typography
                                  fontSize=".9vw"
                                  sx={{ width: "100%", textAlign: "left" }} 
                              >
                                  {option?.service_name || option?.package_name || "-"}
                              </Typography>
                              <Typography
                                  fontSize=".8vw"
                                  fontWeight="bold"
                                  sx={{ 
                                      width: "100%", 
                                      textAlign: "left", 
                                      color: option?.service_charge_id ? "#F1584A" : "#1E972A" 
                                  }}
                              >
                                  {`${option?.service_charge_id ? "Service" : option?.package_id ? "Package" : ""} ${option?.module_type ? ` ( ${option?.module_type} )` : ""}`}
                              </Typography>
                          </Box>
                          )
                        }}                      
                        renderInput={(params) => <TextField {...params} label="Select Investigation" />}
                      />
                    </Box>
                    <Box component={'div'} marginLeft={'1vw'}>
                      <Box component={'div'}>
                        <Typography fontSize={'0.8vw'} fontWeight={600} color={Colors.SecondaryText}>Nurse Name</Typography>
                      </Box>
                      <Autocomplete
                        size='small'
                        sx={{margin:'1vw'}}
                        options={this.state.NurseList || []}
                        getOptionLabel={(option) => option.nurse}
                        value={this.state.nurseName}
                        onChange={(event, newValue) => {
                          this.setState(() => ({
                            nurseName: newValue
                          }))
                        }}
                        renderInput={(params) => (
                          <TextField
                            sx={{ width: "25dvw" }}
                            {...params}
                            label={t("Nurse Name *")}
                          />
                        )}
                      /> 
                    </Box>
                  </Stack>
                </div>
                <Stack spacing={2} direction="row" id='eMed_recPayment_rightBtnCon' sx={{ backgroundColor: Colors.DataTblHeaderbg }} alignItems="center" justifyContent="center">
                  <Button variant='outlined' disabled={this.state.withOutAppointment?.is_ip} size="small" id="eMed_recPayment_btn" onClick={() => { this.handleClear() }}>{t("Clear")}</Button>
                  <Button
                    disabled={this.props.is_From_IpNotes ? false : (CheckAccessFunc("front_office", "In Patients", "Clinical Notes", "Test Order", "SubTab")?.editAccess ? this.state.withOutAppointment?.is_ip : true) || this.state.isAdd}
                    variant='contained' size="small" id="eMed_recPayment_btn"
                    onClick={() => { this.setState({ isAdd: true, }, () => { this.handleAdd() }) }}>{t("Add")}</Button>
                </Stack>
              </Paper>
            </Grid>
          </Grid>
        </Grid>
        {
          this.state.showSuccessResponse ? <ToastMsg severity={"success"} msg={this.state.responseMessage} msgPop={this.msgClose.bind(this)} /> : null
        }
        {
          this.state.showErrorResponse ? <ToastMsg severity={"error"} msg={this.state.responseMessage} msgPop={this.msgClose.bind(this)} /> : null
        }
        {
          states["isHistoryClicked"] ?
            <CommonPopUp width={"75vw"} backgroundColor={Colors.white} popUpClose={this.historyPopUpClose.bind(this)} title={t("History")} component={this._showHistory.bind(this, states["historyData"])} />
            : null
        }
        {states["isTransmit_Pop"] && states["selectionModel"].length > 0 ?
          <ConfirmPopup
            cnfTitle={t('Confirmation')}
            cnfContent={`${t('Please confirm')} ${t(`ForMultiTransmit`)}`}
            cnfAlertPopupClose={this.transmitPopClose.bind(this)}
            cnfData={this.handleTransmit.bind(this)}
            cnfDisable={this.state.isCnfClicked}
          />
          : null}
        {states["isAlreadyExist"] ?
          <ConfirmPopup
            cnfTitle={t('Confirmation')}
            cnfContent={`${t('The')} ${states["test_id"] ? states["test_name"] : states["test_grp_id"] ? states["test_grp"] : ""} ${t('addSameTest')} ?`}
            cnfAlertPopupClose={this.addTestAgainClose.bind(this)}
            cnfData={this.addTestAgain.bind(this)}
            cnfDisable={this.state.isAddCnfClicked}
          />
          : null}
        {this.state.openPopupAddNew && (
          <TemplatePopup
            open={this.state.openPopupAddNew}
            onClose={() => this.setState({ openPopupAddNew: false, templateName: '' })}
            templateName={this.state.templateName || ''}
            setTemplateName={(value) => this.setState({ templateName: value })}
            tempType={this.state.tempType}
            onSubmit={this.postNewTemplateData.bind(this)}
            Title={t("Test Template")}
          />
        )}
        {this.state.templateDeletePopup && (
          <DeletePopup
            DeletTitle={`${t("Are you sure you want to delete")} ${this.state.deleteTemplateName?.name} ?`}
            deleteAlertPopupClose={() => this.setState({ templateDeletePopup: false })}
            removeData={this.deleteTemplateData.bind(this)}
            disable={this.state.removeData}
          />
        )}
        <Loader loaderOpen={this.state.isLoader} />
      </Box>
    )
  }
}
export default withTranslation()(TestOrder);
